@for (modal of slice.modals; track modal) {
  <ng-template #modals>
    <article
      [ngClass]="{
        'kitsune-modal': true,
        'kitsune-modal--has-normal-image': modal.img && modal.imgSize === 'normal',
        'kitsune-modal--content-only': !modal.title && !modal.subtitle && !modal.img,
      }"
    >
      <header mat-dialog-title [class]="getModalHeaderClass(modal)">
        <figure
          [class]="getModalImgAlignmentClass(modal)"
          [ngStyle]="{ 'min-height': modal.imgStaticWidth ? modal.imgStaticWidth + 'px' : null }"
        >
          @if (modal.img) {
            <img
              [class.object-cover]="modal.imgSize === 'cover'"
              [srcset]="modal.img.htmlSrcset"
              [sizes]="getModalImgSizes(modal)"
              [src]="modal.img.smallest.url"
              [alt]="modal.img.alt"
            />
          }
        </figure>
        @if (modal.title) {
          <div class="kitsune-modal__title" [innerHTML]="modal.title"></div>
        }
        @if (modal.subtitle) {
          <div class="kitsune-modal__subtitle" [innerHTML]="modal.subtitle"></div>
        }
        @if (modal.imgSize === 'cover') {
          <div class="absolute top-0 left-0 h-16 w-full kitsune-modal__gradient"></div>
        }
        <button
          [ngClass]="{
            'kitsune-modal__close-btn absolute': true,
            'kitsune-modal__close-btn--negative': modal.imgSize === 'cover',
          }"
          class="kitsune-modal__close-btn absolute"
          mat-dialog-close
        >
          <lib-svg svg="close"></lib-svg>
        </button>
      </header>
      <div class="kitsune-modal__content">
        <mat-dialog-content>
          <ngx-dynamic-hooks data-source="prismic" [content]="modal.content" [options]="{ sanitize: false }">
          </ngx-dynamic-hooks>
        </mat-dialog-content>
        @if (modal.links.length) {
          <mat-dialog-actions align="center" class="flex-col">
            @if (modal.footerText) {
              <span [innerHTML]="modal.footerText"></span>
            }
            @for (link of modal.links; track link) {
              @if (isLinkVisible(link)) {
                <lib-link
                  [link]="link.link"
                  [linkType]="link.type"
                  [linkStyle]="getLinkStyle(link)"
                  [linkSize]="link.size"
                  [icon]="link.icon"
                  [iconPosition]="link.icon_position"
                  (onClick)="onLinkClick(modal)"
                >
                  {{ link.text }}
                </lib-link>
              }
            }
          </mat-dialog-actions>
        }
      </div>
    </article>
  </ng-template>
}
